import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Card, Spinner, Table } from 'react-bootstrap';
import useToken from 'hooks/useToken';
import { useToast } from 'context/providers/ToastProvider';

const PlanesFacturacionMx = ({ idCliente }) => {
    const { token, setToken } = useToken();
    const { showErrorToast } = useToast();
    const [cargando, setCargando] = useState(false);
    const [planes, setPlanes] = useState([]);

    useEffect(() => {
        obtenerPlanesFacturacion();
    }, []);

    const formatHeaderName = (key) => {
        const headerMap = {
            'idPlanFacturaMx': 'ID',
            'vRfc': 'RFC',
            'iCantidades': 'Cantidades',
        };

        return headerMap[key] || key
            .replace(/^[a-z]/, char => char.toUpperCase())
            .replaceAll(/([A-Z])/g, ' $1')
            .trim();
    };

    const obtenerPlanesFacturacion = async () => {
        setCargando(true);
        setPlanes([]);

        try {
            const response = await fetch('/api/cliente/getPlanesFacturacion', {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ idClienteAkasia: idCliente })
            });

            if (response.ok) {
                const data = await response.json();


                if (data?.iResponseType === 1 && data?.detalles) {
                    const detalles = JSON.parse(data.detalles);
                    const table = detalles?.table2 || detalles?.Table2 || [];
                    setPlanes(Array.isArray(table) ? table : []);
                } else {
                    setPlanes(Array.isArray(data) ? data : data?.table1 || []);
                }
            } else {
                if (response.status === 401) {
                    setToken(null);
                    location.href = '';
                }
                showErrorToast(`Error ${response.status}: ${response.statusText}`);
            }
        } catch (error) {
            showErrorToast('Hubo un problema al obtener planes de facturación: ' + error.message);
        } finally {
            setCargando(false);
        }
    };

    const handlePagoDeTimbres = (plan) => {
        console.log('Pago de timbres para plan:', plan);
        // Aquí se puede agregar la lógica para el pago de timbres
    };

    const renderContent = () => {
        if (cargando) {
            return (
                <div className="d-flex align-items-center">
                    <Spinner animation="border" size="sm" className="me-2" />
                    Cargando planes...
                </div>
            );
        }

        if (planes.length === 0) {
            return <p className="mb-0 text-muted">No se encontraron planes.</p>;
        }

        return (
            <div className="planes-table-wrapper">
                <Table responsive className="planes-table">
                    <thead>
                        <tr>
                            {Object.keys(planes[0]).map((key) => (
                                <th key={key}>
                                    {formatHeaderName(key)}
                                </th>
                            ))}
                            <th style={{ width: '120px' }}>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {planes.map((plan) => (
                            <tr key={JSON.stringify(plan)}>
                                {Object.keys(planes[0]).map((key) => (
                                    <td key={key}>
                                        {String(plan[key] ?? '')}
                                    </td>
                                ))}
                                <td>
                                    <Button 
                                        size="sm" 
                                        variant="success"
                                        onClick={() => handlePagoDeTimbres(plan)}
                                        className="w-100"
                                    >
                                        Pago de timbres
                                    </Button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </div>
        );
    };

    return (
        <Card className="mt-3">
            <Card.Header className="d-flex justify-content-between align-items-center border-bottom border-200">
                <h5 className="mb-0">Planes de facturación Mx</h5>      
            </Card.Header>
            <Card.Body style ={{ maxHeight: '350px', overflowY: 'auto' }}>
                {renderContent()}
            </Card.Body>
        </Card>
    );
};

PlanesFacturacionMx.propTypes = {
    idCliente: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
};

export default PlanesFacturacionMx;
